/* eslint-disable quote-props, key-spacing */
const redux2CartApi = {
  'buyOnlineShipToStore':   'ShipToStore',
  'buyOnlinePickupInStore': 'BOPIS',
  'shipToHome':             'ShipToHome',
  'deliverFromStore':       'DeliverFromStore',
  'directDelivery':         'DirectDelivery',
};

export default function toCartFulfillmentMethod(fulfillmentMethod) {
  return redux2CartApi[fulfillmentMethod];
}
